import { render, staticRenderFns } from "./Lang.vue?vue&type=template&id=39a5f04e&scoped=true"
import script from "./Lang.vue?vue&type=script&lang=js"
export * from "./Lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a5f04e",
  null
  
)

export default component.exports